/**
 * @generated SignedSource<<8bb6a6520e87d2586692d4d980338f83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
export type FeedSelectorDropdownQuery$variables = {
  first?: number | null;
  id: string;
};
export type FeedSelectorDropdownQuery$data = {
  readonly organization: {
    readonly feeds?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly app: {
            readonly badge: {
              readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
            };
            readonly collection: {
              readonly id: string;
            } | null;
            readonly contentUsage: {
              readonly id: string;
            } | null;
            readonly customAppTitle: string | null;
            readonly customAppUrl: string | null;
            readonly feed: {
              readonly id: string;
              readonly name: string;
              readonly viewerPermissions: ReadonlyArray<string>;
              readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
            } | null;
            readonly forYouDashboard: {
              readonly id: string;
            } | null;
            readonly id: string;
            readonly kind: ProductAppKind;
            readonly linkProduct: {
              readonly slug: string;
            } | null;
            readonly product: {
              readonly name: string;
              readonly slug: string;
              readonly " $fragmentSpreads": FragmentRefs<"appLevelContextFragment" | "usePermissionsFragment">;
            } | null;
            readonly productApps: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly chatChannel: {
                    readonly externalChannelId: string;
                  } | null;
                  readonly id: string;
                };
              }>;
            } | null;
            readonly " $fragmentSpreads": FragmentRefs<"AppSidebarItemFragment" | "AppUtils_getLocationFragment" | "ChatChannelSettingsModalButtonFragment" | "ChatChannelSideBarItemFragment" | "CollectionAppSettingsButtonFragment" | "ContentAppSettingsButtonFragment" | "DashboardAppSettingsButtonFragment" | "EventsAppSettingsButtonFragment" | "FeedAppSettingsButtonFragment" | "GenericAppSettingsButtonFragment" | "LinkAppSettingsButtonFragment" | "MembersAppSettingsButtonFragment" | "NavFolderSettingsDropdownFragment">;
          };
          readonly id: string;
          readonly name: string;
          readonly viewerPermissions: ReadonlyArray<string>;
        };
      }>;
    };
    readonly products?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly badge: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly feeds: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string;
                readonly viewerPermissions: ReadonlyArray<string>;
              };
            }>;
          };
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly startDate: string | null;
          readonly status: ProductStatus;
          readonly waitingRoomEndsAt: string | null;
        };
      }>;
    };
  } | null;
};
export type FeedSelectorDropdownQuery = {
  response: FeedSelectorDropdownQuery$data;
  variables: FeedSelectorDropdownQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "Literal",
  "name": "canPost",
  "value": true
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "excludeProductLevel",
    "value": true
  },
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BadgeFragment"
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v13 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "usePermissionsFragment"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v15 = [
  (v6/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v18 = [
  (v14/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "forYouDashboard",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "course"
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitingRoomEndsAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FeedNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Feed",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfoObjectType",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v31 = {
  "alias": "nonNullProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v32 = [
  (v31/*: any*/),
  (v30/*: any*/)
],
v33 = {
  "alias": "nullableProductId",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v34 = [
  (v33/*: any*/),
  (v30/*: any*/)
],
v35 = {
  "alias": "nullableProductIdString",
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v36 = [
  (v8/*: any*/)
],
v37 = [
  (v31/*: any*/),
  (v8/*: any*/),
  (v30/*: any*/)
],
v38 = [
  (v33/*: any*/),
  (v8/*: any*/),
  (v30/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v29/*: any*/),
        (v8/*: any*/),
        (v30/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v35/*: any*/),
        (v8/*: any*/),
        (v30/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v36/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v42 = [
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedSelectorDropdownQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "FeedNodeConnection",
                "kind": "LinkedField",
                "name": "feeds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "app",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feed",
                                "kind": "LinkedField",
                                "name": "feed",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v7/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "appLevelContextFragment"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductAppNodeConnection",
                                "kind": "LinkedField",
                                "name": "productApps",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductAppNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductApp",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChatChannel",
                                            "kind": "LinkedField",
                                            "name": "chatChannel",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "AppSidebarItemFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ContentAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "LinkAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "FeedAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "GenericAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "CollectionAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ChatChannelSettingsModalButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ChatChannelSideBarItemFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "NavFolderSettingsDropdownFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "EventsAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "MembersAppSettingsButtonFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "DashboardAppSettingsButtonFragment"
                              },
                              {
                                "kind": "InlineDataFragmentSpread",
                                "name": "AppUtils_getLocationFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": (v18/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Feed",
                                    "kind": "LinkedField",
                                    "name": "feed",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChatChannel",
                                    "kind": "LinkedField",
                                    "name": "chatChannel",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "args": null,
                                "argumentDefinitions": []
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": "feeds",
                            "args": [
                              (v3/*: any*/)
                            ],
                            "concreteType": "FeedNodeConnection",
                            "kind": "LinkedField",
                            "name": "__ProductFeedSelectorDropdown_feeds_connection",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": "__ProductFeedSelectorDropdown_feeds_connection(canPost:true)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "products(type:\"course\")"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeedSelectorDropdownQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v26/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "FeedNodeConnection",
                "kind": "LinkedField",
                "name": "feeds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductApp",
                            "kind": "LinkedField",
                            "name": "app",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feed",
                                "kind": "LinkedField",
                                "name": "feed",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v26/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v29/*: any*/),
                                          (v30/*: any*/)
                                        ],
                                        "type": "Product",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v32/*: any*/),
                                        "type": "Event",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v34/*: any*/),
                                        "type": "Comment",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v34/*: any*/),
                                        "type": "Feed",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v34/*: any*/),
                                        "type": "Post",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v35/*: any*/),
                                          (v30/*: any*/)
                                        ],
                                        "type": "ContentUsage",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v34/*: any*/),
                                        "type": "ChatChannel",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v34/*: any*/),
                                        "type": "Dashboard",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v32/*: any*/),
                                        "type": "AssignmentSubmission",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v7/*: any*/),
                                  (v39/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "connectedApps",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "includeNested",
                                        "value": true
                                      }
                                    ],
                                    "concreteType": "ProductAppNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "productApps",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductAppNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductApp",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "productApps(includeNested:true)"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductMembership",
                                    "kind": "LinkedField",
                                    "name": "viewerMembership",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "linkProduct",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductAppNodeConnection",
                                "kind": "LinkedField",
                                "name": "productApps",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductAppNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductApp",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ChatChannel",
                                            "kind": "LinkedField",
                                            "name": "chatChannel",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v6/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalCount",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v23/*: any*/),
                              (v40/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "navSectionId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ChatChannel",
                                "kind": "LinkedField",
                                "name": "chatChannel",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v20/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "concreteType": "FeedNodeConnection",
                            "kind": "LinkedField",
                            "name": "feeds",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v42/*: any*/),
                            "filters": [
                              "canPost"
                            ],
                            "handle": "connection",
                            "key": "ProductFeedSelectorDropdown_feeds",
                            "kind": "LinkedHandle",
                            "name": "feeds"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "products(type:\"course\")"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "89ec9c791a04496848f278d6a0ed6657",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    },
    "name": "FeedSelectorDropdownQuery",
    "operationKind": "query",
    "text": "query FeedSelectorDropdownQuery(\n  $id: ID!\n  $first: Int\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      feeds(first: $first, canPost: true, excludeProductLevel: true) {\n        edges {\n          node {\n            id\n            name\n            viewerPermissions\n            app {\n              badge {\n                ...BadgeFragment\n                id\n              }\n              id\n              kind\n              customAppUrl\n              customAppTitle\n              feed {\n                id\n                name\n                viewerPermissions\n                ...usePermissionsFragment\n              }\n              product {\n                slug\n                name\n                ...usePermissionsFragment\n                ...appLevelContextFragment\n                id\n              }\n              collection {\n                id\n              }\n              contentUsage {\n                id\n              }\n              linkProduct {\n                slug\n                id\n              }\n              productApps {\n                edges {\n                  node {\n                    id\n                    chatChannel {\n                      externalChannelId\n                      id\n                    }\n                  }\n                }\n              }\n              forYouDashboard {\n                id\n              }\n              ...AppSidebarItemFragment\n              ...ContentAppSettingsButtonFragment\n              ...LinkAppSettingsButtonFragment\n              ...FeedAppSettingsButtonFragment\n              ...GenericAppSettingsButtonFragment\n              ...CollectionAppSettingsButtonFragment\n              ...ChatChannelSettingsModalButtonFragment\n              ...ChatChannelSideBarItemFragment\n              ...NavFolderSettingsDropdownFragment\n              ...EventsAppSettingsButtonFragment\n              ...MembersAppSettingsButtonFragment\n              ...DashboardAppSettingsButtonFragment\n              ...AppUtils_getLocationFragment\n            }\n          }\n        }\n      }\n      products(type: \"course\") {\n        edges {\n          node {\n            id\n            name\n            status\n            slug\n            startDate\n            waitingRoomEndsAt\n            badge {\n              ...BadgeFragment\n              id\n            }\n            feeds(first: $first, canPost: true) {\n              edges {\n                node {\n                  id\n                  name\n                  viewerPermissions\n                  __typename\n                }\n                cursor\n              }\n              pageInfo {\n                endCursor\n                hasNextPage\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment CollectionAppSettingsButtonFragment on ProductApp {\n  id\n  ...CollectionAppSettingsModalFragment\n}\n\nfragment CollectionAppSettingsModalFragment on ProductApp {\n  id\n}\n\nfragment ContentAppSettingsButtonFragment on ProductApp {\n  id\n  ...ContentAppSetupModalFragment\n}\n\nfragment ContentAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment DashboardAppSettingsButtonFragment on ProductApp {\n  id\n  ...DashboardAppSetupModalFragment\n}\n\nfragment DashboardAppSetupModalContentFragment on ProductApp {\n  id\n  forYouDashboard {\n    id\n  }\n}\n\nfragment DashboardAppSetupModalFragment on ProductApp {\n  customAppTitle\n  forYouDashboard {\n    id\n  }\n  ...DashboardAppSetupModalContentFragment\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment DeleteNavFolderButtonFragment on ProductApp {\n  id\n  customAppTitle\n  productApps {\n    totalCount\n  }\n}\n\nfragment EventsAppSettingsButtonFragment on ProductApp {\n  id\n  ...EventsAppSetupModalFragment\n}\n\nfragment EventsAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment FeedAppSettingsButtonFragment on ProductApp {\n  id\n  ...FeedAppSetupModalFragment\n}\n\nfragment FeedAppSetupModalFragment on ProductApp {\n  id\n}\n\nfragment GenericAppSettingsButtonFragment on ProductApp {\n  id\n  ...GenericAppSettingsModalFragment\n}\n\nfragment GenericAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment LinkAppSettingsButtonFragment on ProductApp {\n  id\n  ...LinkAppSetupModalFragment\n}\n\nfragment LinkAppSetupModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MemberDirectoryAppSettingsModalFragment on ProductApp {\n  id\n  kind\n}\n\nfragment MembersAppSettingsButtonFragment on ProductApp {\n  id\n  kind\n  productId\n  ...MemberDirectoryAppSettingsModalFragment\n}\n\nfragment NavFolderSettingsButtonFragment on ProductApp {\n  id\n}\n\nfragment NavFolderSettingsDropdownFragment on ProductApp {\n  id\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  ...NavFolderSettingsButtonFragment\n  ...DeleteNavFolderButtonFragment\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "aee97acfcc61e8bbc083e12cbcc39506";

export default node;
